import { TextInputField } from "@components/Inputs/TextInputField/TextInputField";
import { UserFieldErrorMessages } from "@constants/Errors";
import { phoneNumberChange } from "@services/ErrorHandling";
import { handlePostCodeChange } from "@services/ErrorHandling";
import { TenantFieldErrorMessages } from "@constants/Errors";
import { USER } from "@types/user";

type UserCompanyInfoCardProps = {
  userData: USER;
  updateUserData: (field: string, value: any) => void;
  errors: any;
  updateError: (field: string, value: any) => void;
};

export const UserCompanyInfoCard = ({
  userData,
  updateUserData,
  errors,
  updateError,
}: UserCompanyInfoCardProps) => {
  return (
    <div>
      <div className="w-full md:w-3/5">
        <TextInputField
          label={"支社名"}
          providedClassName="form-text-field-border-full"
          value={userData?.company_name}
          placeholder="株式支社サンプル"
          onChange={(e) => {
            updateUserData("company_name", e.target.value);
            updateUserData("company_info_updated", true);
          }}
        />
        {errors.company_name && (
          <p className="text-red-500">{UserFieldErrorMessages.nameError}</p>
        )}
      </div>
      <div className="divider mt-5 mb-6"></div>

      <div className="w-full md:w-3/5">
        <TextInputField
          label={"支社郵便番号 （ハイフンなし）"}
          providedClassName="form-text-field-border-full"
          value={userData?.company_postal_code}
          placeholder="1234567"
          onChange={(e) => {
            handlePostCodeChange(
              "company_postal_code",
              e.target.value,
              updateUserData,
              updateError,
            );
            updateUserData("company_info_updated", true);
          }}
        />
        {errors.company_postal_code && (
          <p className="text-red-500">
            {TenantFieldErrorMessages.postcodeError}
          </p>
        )}
      </div>

      <div className="divider mt-5 mb-6"></div>

      <div className="w-full md:w-3/5">
        <TextInputField
          label={"支社住所"}
          providedClassName="form-text-field-border-full"
          className={"form-text-field-border"}
          value={userData?.company_address}
          placeholder="東京都中央区サンプル町1-2-3"
          onChange={(e) => {
            updateUserData("company_address", e.target.value);
            updateUserData("company_info_updated", true);
          }}
        />
        {errors.company_address && (
          <p className="text-red-500">
            {TenantFieldErrorMessages.postcodeError}
          </p>
        )}
      </div>

      <div className="divider mt-5 mb-6"></div>

      <div className="w-full md:w-3/5">
        <TextInputField
          label={"支社電話番号 （ハイフンなし）"}
          providedClassName="form-text-field-border-full"
          placeholder="（例）0312345678"
          value={userData?.company_tel}
          onChange={(e) => {
            phoneNumberChange(
              "company_tel",
              e.target.value,
              updateUserData,
              updateError,
            );
            updateUserData("company_info_updated", true);
          }}
        />
        {errors.company_tel && (
          <p className="text-red-500">
            {UserFieldErrorMessages.telephoneNumberError}
          </p>
        )}
      </div>

      <div className="divider mt-5 mb-6"></div>

      <div className="w-full md:w-3/5">
        <TextInputField
          label={"支社FAX番号 （ハイフンなし）"}
          providedClassName="form-text-field-border-full"
          value={userData?.company_fax}
          placeholder="（例）0312345678"
          onChange={(e) => {
            phoneNumberChange(
              "company_fax",
              e.target.value,
              updateUserData,
              updateError,
            );
            updateUserData("company_info_updated", true);
          }}
        />
        {errors.company_fax && (
          <p className="text-red-500">
            {UserFieldErrorMessages.faxNumberError}
          </p>
        )}
      </div>
    </div>
  );
};
